export default (props, vars) => () =>
  vars?.['usestatepresentationpopupopened']?.['setState'](undefined);
